import { PropsWithChildren } from 'react'
import Styles from './PersistentToast.module.scss'

export const Content = ({ children }: PropsWithChildren<{}>) => <div className={Styles.content}>{children}</div>
